import React, {Component} from 'react'
import Header from "../components/GetToKnow/Header";
import Mission from "../components/GetToKnow/Mission";
import VideoSection from "../components/GetToKnow/VideoSection";
import VideoModal from "../components/Modals/VideoModal";
import OurStory from "../components/GetToKnow/OurStory";
import Timeline from "../components/GetToKnow/Timeline";
import MrNgoStory from "../components/GetToKnow/MrNgoStory";
import Team from "../components/GetToKnow/Team";
import TeamModal from "../components/Modals/TeamModal";

import hngutils from "../assets/libs/hngutils";

class GetToKnow extends Component {
    constructor(props) {
      super(props);

      this.props.data.allWordpressPage.edges.forEach(edge => {
        hngutils.imageSrcToLocalFile(edge.node.acf.image);
        hngutils.imageSrcToLocalFile(edge.node.acf.image_one);
        hngutils.imageSrcToLocalFile(edge.node.acf.image_two);
        hngutils.imageSrcToLocalFile(edge.node.acf.background_image);
      });      

      this.props.data.teamData.edges.forEach(edge => {
        hngutils.imageSrcToLocalFile(edge.node.acf.image);
      });

      this.props.data.mrNgoStory.edges.forEach(edge => {
        hngutils.imageSrcToLocalFile(edge.node.acf.story_image);
      });

      this.props.data.mrNgoStoryBG.edges.forEach(edge => {
        hngutils.imageSrcToLocalFile(edge.node.acf.background_image);
      });
    }

    state = {
        teamModalOpen: false,
        teamModalId: "",
        modalData: {},
        videoModalOpen: false,
    };

    handleTeamClick = (id) => {
        this.setState({
            teamModalOpen: true,
            teamModalId: id
        })
    };

    handleVideoClick = () => {
        this.setState({
            videoModalOpen: true
        })
    };

    handleTeamClose = () => {
        this.setState({
            teamModalOpen: false,
            teamModalId: ""
        })
    };

    handleVideoClose = () => {
        this.setState({
            videoModalOpen: false
        })
    };

    render() {
        const {allWordpressPage, teamData, timelineData, video, mrNgoStory, mrNgoStoryBG} = this.props.data;
        const mrNgoData = mrNgoStory.edges.map((i, index) => {
            const {title, acf: {story_text, story_image: {source_url, alt_text}}} = i.node;
            return ({title, story_text, source_url, alt_text, index})
        });
        const pageData = allWordpressPage.edges.map(i => {
            const {menu_order, title, content, acf} = i.node;
            return ({menu_order, title, content, acf})
        }).sort((a, b) => a.menu_order - b.menu_order);
        const team = teamData.edges.map(i => {
            const {id, content, acf: {name, position, image}} = i.node;
            return (
              {
                  id,
                  name,
                  position,
                  image,
                  content
              }
            )
        });
        const {teamModalOpen, videoModalOpen} = this.state;
        const selectedModal = team.filter(i => {
            return i.id === this.state.teamModalId
        });
        const timeline = timelineData.edges.map(i => {
            const {text, year} = i.node.acf;
            return {text, year}
        }).sort((a, b) => a.year - b.year);
        return (
          <div>
              <Header data={pageData[0].acf}/>
              <Mission data={pageData[1].acf}/>
              <VideoSection onClick={() => this.handleVideoClick()}/>
              <VideoModal
                isOpen={videoModalOpen}
                close={() => this.handleVideoClose()}
                video={video.edges[0].node.acf.video_link}
              />
              <OurStory data={pageData[3]}/>
              <Timeline timeline={timeline}/>
              <MrNgoStory
                data={mrNgoData}
                bgImage={mrNgoStoryBG}
              />
              {
                  teamModalOpen && (
                    <TeamModal
                      isOpen={teamModalOpen}
                      close={() => this.handleTeamClose()}
                      modalData={selectedModal[0]}
                    />
                  )
              }
              <Team
                onClick={(id) => this.handleTeamClick(id)}
                team={team}
              />
          </div>
        )
    }
}

export default GetToKnow

// get to know page wordpress_parent = 189

export const getToKnowQuery = graphql`
    query getToKnowQuery {
        allWordpressPage(filter: {wordpress_parent: {eq: 189}}) {
            edges {
                node {
                    title
                    menu_order
                    content
                    acf {
                        header
                        subheader
                        paragraph
                        image {
                            source_url
                            alt_text
                            description
                            title
                            caption
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                        image_one {
                            id
                            source_url
                            alt_text
                            title
                            caption
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                        image_two {
                            id
                            source_url
                            alt_text
                            title
                            caption
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                        background_image {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                    }
                }
            }
        }
        teamData: allWordpressPost(
            filter: {acf: {type: {eq: "team"}}}
            sort:{ fields: [date]}) {
            edges {
                node {
                    id
                    date
                    content
                    acf {
                        name
                        position
                        image {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                    }
                }
            }
        }
        timelineData: allWordpressPost(
            filter: {acf: {type: {eq: "timeline"}}}) {
            edges {
                node {
                    content
                    acf {
                        year
                        text
                    }
                }
            }
        }
        video: allWordpressPage(filter: {title: {eq: "Video Link"}}) {
            edges {
                node {
                    acf {
                        video_link
                    }
                }
            }
        }
        mrNgoStory: allWordpressPage(filter: {acf: {type : {eq: "mrngostory"}}}, sort: {fields: [date]}) {
            edges {
                node {
                    title
                    acf {
                        story_text
                        story_image {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                    }
                }
            }
        }
        mrNgoStoryBG: allWordpressPage(filter: {wordpress_id: {eq: 864}}) {
            edges {
                node {
                    acf {
                        background_image {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                    }
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/get-to-know.js